var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalData && _vm.modalData.type === "drugs"
        ? _c("editDetailsModal", {
            attrs: {
              modalData: _vm.modalData,
              onModalClose: _vm.closeModal,
              onModalAccept: _vm.updateOrderDetailsByType,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.modalData &&
      (_vm.modalData.type === "comment" || _vm.modalData.type === "reject")
        ? _c("addCommentModal", {
            attrs: {
              modalData: _vm.modalData,
              onModalClose: _vm.closeModal,
              onModalAccept: () =>
                _vm.addComment(_vm.modalData.comment, _vm.modalData.type),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.modalData && _vm.modalData.type === "status"
        ? _c("addCommentModal", {
            attrs: {
              modalData: _vm.modalData,
              onModalClose: _vm.closeModal,
              onModalAccept: () => _vm.updateStatus(_vm.modalData.order),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass:
            "table table-sm table-bordered table-hover orders_profile_table",
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.orders, function (order, index) {
              return order
                ? _c("tr", [
                    _c("td", [
                      _vm.permissions.allowToSelect
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selected[order.id],
                                expression: "selected[order.id]",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.selected[order.id])
                                ? _vm._i(_vm.selected[order.id], null) > -1
                                : _vm.selected[order.id],
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selected[order.id],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.selected,
                                        order.id,
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.selected,
                                        order.id,
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.selected, order.id, $$c)
                                }
                              },
                            },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [_vm._v(_vm._s(index + 1))]),
                      _vm._v(" (" + _vm._s(order.id) + ")\n        "),
                      _c("p", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm.printDate(order.created_at))),
                      ]),
                      _vm._v(" "),
                      _vm.supplyOrders
                        ? _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.printSupplyStatus(order.related_order_id)
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(order.client_name) +
                              "\n          "
                          ),
                          _c("hr"),
                          _vm._v(" "),
                          order.order_phones.length
                            ? _vm._l(order.order_phones, function (phone) {
                                return _c("p", [
                                  _c("strong", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.printPhone(phone)),
                                    },
                                  }),
                                ])
                              })
                            : [_c("p", [_vm._v(_vm._s(order.phone))])],
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("p", [_vm._v(_vm._s(order.address))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("доставка: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.moment(order.delivery_date))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", {
                        staticClass: "table_div",
                        domProps: {
                          innerHTML: _vm._s(_vm.printDrugs(order.details)),
                        },
                      }),
                      _vm._v(" "),
                      _vm.permissions.allowToEditDrugs
                        ? _c("div", { staticClass: "text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info btn-xs",
                                on: {
                                  click: function ($event) {
                                    return _vm.editDrugsModal(
                                      order,
                                      order.details
                                    )
                                  },
                                },
                              },
                              [_vm._v("Редактировать")]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", {
                        staticClass: "table_div",
                        domProps: {
                          innerHTML: _vm._s(_vm.printComments(order.comment)),
                        },
                      }),
                      _vm._v(" "),
                      _vm.permissions.allowToComment
                        ? _c("div", { staticClass: "text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success btn-xs",
                                on: {
                                  click: function ($event) {
                                    return _vm.addCommentModal(order)
                                  },
                                },
                              },
                              [_vm._v("Добавить")]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("p", [_c("strong", [_vm._v(_vm._s(order.price))])]),
                      _vm._v(" "),
                      _vm.rates && _vm.rates[38] && _vm.rates[38] != 1
                        ? _c("p", [
                            _c("strong", [
                              _vm._v(
                                "(" +
                                  _vm._s(
                                    Math.round(
                                      order.price * _vm.rates[38] * 10
                                    ) / 10
                                  ) +
                                  ")"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _vm.permissions.allowToReject
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-warning btn-xs mb-1",
                                on: {
                                  click: function ($event) {
                                    return _vm.addCommentModal(order, "reject")
                                  },
                                },
                              },
                              [_vm._v("Отменить\n        ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.permissions.allowToComplete
                          ? [
                              order.status === 4
                                ? [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-success btn-xs mb-1",
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateStatus(order, true)
                                          },
                                        },
                                      },
                                      [_vm._v("Доставить")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-warning btn-xs mb-1",
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateStatus(
                                              order,
                                              true,
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Отменить\n            ")]
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              order.status === 5
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-pill badge-success",
                                    },
                                    [_vm._v("Доставлено")]
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ])
                : _vm._e()
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Клиент")]),
        _vm._v(" "),
        _c("th", [_vm._v("Адрес")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "90" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }